import React, { useEffect, useRef, useState } from "react";
import IconTextBtn from "../../../form/icon-text-btn";
import { AddIcon, AddNewScreenIcon, DeleteIcon } from "../../../svg";
import IconBtn from "../../../form/icon-btn";
import { v4 as uuidv4 } from "uuid";
import ManipulationValidationComponent from "./indexManipulationValidation";

const GridComponent = ({
  register,
  processData,
  selectedScreen,
  currentQuestion,
  setProcessData,
  isReadOnly,
}: any) => {
  //#region Grid Function
  const [rows, setRows] = useState<any[][]>([]);
  const [validationType, setValidationType] = useState("1"); // 1 for "Other", 2 for "Min & Max"
  const [manipulationType, setManipulationType] = useState("");
  const hasExecutedRef = useRef(0);
  const [showManipulationValidation, setShowManipulationValidation] = useState(false);
  const [manipulationValue, setManipulationValue] = useState("");
  const [validationValue, setValidationValue] = useState("");
  const [uniqueId, setUniqueId] = useState("");

  const handleAddNewRow = () => {
    const newRows = [...rows, [{
      id: "",
      uniqueId: generateGuid(),
      placeHolder: "",
      rowIndex: "",
      columnIndex: "",
      columnSize: "",
      type: 7,
      subType: 0,
      typeValidations: null,
      typeManipulations: null,
    }]];
    setRows(newRows);
    updateProcessDataWithRows(newRows, "", "", "");
  };

  const handleAddNewColumn = (rowIndex: number) => {
    const updatedRows = [...rows];
    if (updatedRows[rowIndex].length < 4) {
      const newColumn = {
        id: "",
        uniqueId: generateGuid(),
        placeHolder: "",
        rowIndex: "",
        columnIndex: "",
        columnSize: "",
        type: 7,
        subType: 0,
        typeValidations: null,
        typeManipulations: null,
      };
      updatedRows[rowIndex] = [...updatedRows[rowIndex], newColumn];
      setRows(updatedRows);
      updateProcessDataWithRows(updatedRows, "", "", "");
      
    }
  };

  const handleDeleteRow = (rowIndex: number) => {
    const updatedRows = rows.filter((_, i) => i !== rowIndex);
    setRows(updatedRows);
    updateProcessDataWithRows(updatedRows, "", "", "");
  };

  const handleDeleteColumn = (rowIndex: number, colIndex: number) => {
    const updatedRows = [...rows];
    if (updatedRows[rowIndex].length > 1) {
      updatedRows[rowIndex].splice(colIndex, 1);
      setRows(updatedRows);
      updateProcessDataWithRows(updatedRows, "", "", "");
    }
  };

  const handleAddIconClick = (typeValidationData: any, typeManipulationsData:any, uniqueIdParams:any) => {
    setShowManipulationValidation(true);  
    setUniqueId(uniqueIdParams);

    if (typeManipulationsData) {
      setManipulationType(typeManipulationsData[0].type);
      setManipulationValue(typeManipulationsData[0].result);
    }
    else{
      setManipulationType("");
      setManipulationValue("");
    }
  
    if (typeValidationData) {
      setValidationType(typeValidationData[0].type);
      setValidationValue(typeValidationData[0].result);
    }
    else{
      setValidationType("");
      setValidationValue("");
    }
  
  };

  const handleInputChange = (
    rowIndex: number,
    colIndex: number,
    value: string,
    uniqueId: string,
  ) => {
    const updatedRows = [...rows];
    const updatedObject = {...updatedRows[rowIndex][colIndex]}
    updatedObject.placeHolder = value;

    updatedRows[rowIndex][colIndex] = updatedObject;
    setRows(updatedRows);
    updateProcessDataWithRows(updatedRows, "", "", "");
  };

  const generateGuid = () => {
    return uuidv4();
  };
  // Function to update processData whenever rows are modified
  const updateProcessDataWithRows = (updatedRows: any[][], value: any, uniqueId: any, idValue: any) => {
    const itemIndex = processData.findIndex((item: any) => {
      return item.uniqueId === selectedScreen.uniqueId;
    });
  
    if (itemIndex !== -1) {
      const updatedProcessData = [...processData];
      const updatedItem = { ...processData[itemIndex] };
  
      const screenDetailIndex = updatedItem.questionDetails.findIndex(
        (item: any) => item.id === currentQuestion?.id
      );
      
      if (screenDetailIndex !== -1) {
        const formattedGridValues = updatedRows.flatMap((row, rIndex) => {
          const totalColumns = row.length;
          const columnSize = Math.floor(12 / totalColumns);
          return row.map((colValue: any, cIndex) => {
            const isTargetUniqueId = colValue.uniqueId === uniqueId;
            return {
              id: updatedItem.questionDetails[screenDetailIndex].id,
              uniqueId: colValue.uniqueId,
              placeHolder: colValue.placeHolder || "",
              rowIndex: rIndex,
              columnIndex: cIndex,
              columnSize: columnSize,
              type: 7,
              subType: 0,
              typeValidations:
              colValue.typeValidations !== null
                ? isTargetUniqueId && idValue === "validationResult"
                  ? value
                  : colValue.typeValidations
                : isTargetUniqueId && idValue === "validationResult"
                ? value
                : null,
            typeManipulations:
              colValue.typeManipulations !== null
                ? isTargetUniqueId && idValue === "manipulationResult"
                  ? value
                  : colValue.typeManipulations
                : isTargetUniqueId && idValue === "manipulationResult"
                ? value
                : null,
            };
          });
        });


        const updatedScreenDetail = {
          ...updatedItem.questionDetails[screenDetailIndex],
          gridValues: formattedGridValues,
        };
        
        updatedItem.questionDetails[screenDetailIndex] = updatedScreenDetail;    
        updatedProcessData[itemIndex] = updatedItem;
  
        setProcessData(updatedProcessData);

        const updatedRowsState = updatedRows.map((row) =>
          row.map((colValue) => {
            if (colValue.uniqueId === uniqueId) {
              return {
                ...colValue,
                typeValidations:
                  idValue === "validationResult" ? value : colValue.typeValidations,
                typeManipulations:
                  idValue === "manipulationResult" ? value : colValue.typeManipulations,
              };
            }
            return colValue;
          })
        );
        setRows(updatedRowsState);
      }
    }
  };
  
  const handleManipulationValidation = (Value:any, idValue:any, uniqueId: any, typeValue: any) => {
    if(idValue === "manipulationType"){
      setManipulationValue(Value);
    }
    const updatedRows = [...rows];
    updateProcessDataWithRows(updatedRows, Value, uniqueId, idValue);
  };
  useEffect(()=>{
    if (currentQuestion?.gridValues) {
      const groupedRows = currentQuestion.gridValues.reduce((acc: any[][], item: any) => {
        acc[item.rowIndex] = acc[item.rowIndex] || []; // Initialize if not exists
        acc[item.rowIndex].push(item); // Push item to corresponding rowIndex group
        return acc;
      }, []);
  
      setRows(groupedRows);
    } else {
      setRows(rows); // Keep previous state if no gridValues
    }
  }, [])
  //#endregion
  return (
    <div className="grid grid-cols-1 gap-4 mb-4 p-3 m-10 bg-white rounded-lg dark:bg-[#272936]">
      <div className="w-full flex justify-end pr-2 mb-4">
        <IconTextBtn
          icon={<AddNewScreenIcon />}
          label="Add Row"
          btnSize="large"
          handleClick={() => handleAddNewRow()}
        />
      </div>
      {rows.map((row: any, rowIndex: any) => (
        <div key={rowIndex} className="w-full flex items-center mb-3">
          <div className="flex w-[90%] relative">
            {/* {row.map((col: any, colIndex: number) => ( */}
              {(Array.isArray(row) ? row : []).map((col: any, colIndex: number) => (
              <div
                key={colIndex}
                className="relative flex items-center mr-4 w-full max-xl:mr-2"
              >
                <input
                  className="flex-1 text-[1.2rem] font-inter font-medium text-io-black dark:text-io-white border border-io-primary bg-transparent px-[2rem] py-[1.2rem] rounded-[0.5rem] pr-10
                  max-xl::text-[1rem] max-xl:py-[1rem] max-xl:pr-5 max-xl:px-[1rem] lg:w-[80%] xl:w-[70%]" 
                  {...register(`resolutionType-${rowIndex}-${colIndex}`)}
                  value={col.placeHolder}
                  placeholder="Name"
                  onChange={(e) =>
                    handleInputChange(rowIndex, colIndex, e.target.value, uniqueId)
                  }
                  onClick={(e) => e.stopPropagation()}
                />
                {/* Move the Delete Icon below the input */}
                <div className="absolute top-1/2 right-2 transform -translate-y-1/2">
                <IconBtn
                    icon={<AddIcon />}
                    size="w-[1.6rem]"
                    handleClick={(e) => {
                      e.stopPropagation();
                      handleAddIconClick(col.typeValidations, col.typeManipulations, col.uniqueId);
                    }}
                  />
                  <IconBtn
                    icon={<DeleteIcon />}
                    size="w-[1.6rem]" // Icon size
                    handleClick={(e) => {
                      e.stopPropagation();
                      handleDeleteColumn(rowIndex, colIndex);
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="flex justify-end ml-auto">
            <div className="w-full flex justify-end pr-2 mb-4">
              <IconTextBtn
                icon={<AddNewScreenIcon />}
                label=""
                btnSize="large"
                handleClick={() => handleAddNewColumn(rowIndex)}
                disabled={row.length >= 4}
              />
            </div>
            <div className="w-full flex justify-end pr-2 mb-4">
              <IconTextBtn
                icon={<DeleteIcon />}
                label=""
                btnSize="large"
                handleClick={() => handleDeleteRow(rowIndex)}
              />
            </div>
          </div>
        </div>
      ))}
      {showManipulationValidation && (
        <ManipulationValidationComponent
          selectedScreen={selectedScreen}
          register={register}
          processData={processData}
          setProcessData={setProcessData}
          currentQuestion={currentQuestion}
          hasExecutedRef={hasExecutedRef}
          manipulationType={manipulationType}
          validationType={validationType}
          manipulationValue={manipulationValue}
          validationValue={validationValue}
          uniqueId={uniqueId}
          type={2}
          handleManipulationValidation={handleManipulationValidation}
        />
      )}
    </div>
  );
};

export default GridComponent;
